import { render, staticRenderFns } from "./FormAssetColor.vue?vue&type=template&id=1f8306cc"
import script from "./FormAssetColor.vue?vue&type=script&lang=js"
export * from "./FormAssetColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports